export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8278.63c8bf17.jpg";